import React from 'react';
import actionCable from 'actioncable';
import { get } from 'lodash-es';

import { ButtonGroup, Button, StatusMessage, Link } from '../components/library-components';

import { addSubscriptionMembersFromCSV, getSubscriptionMemberImportReports, getDownloadUrl } from '../api';

export default class ImportMemberCsv extends React.Component {
  constructor () {
    super();
    this.state = {
      membersCsv: '',
      isImportDisabled: false,
      showNotification: false,
      notification: {}
    };
    this.notifyUser = this.notifyUser.bind(this);
  }

  cableApp () {
    return {
      cable: function () {
        return actionCable.createConsumer(
          window.actionCableNotifier.websocketServerUrl
        );
      }
    };
  }

  setupChannelSubscription (channel, callback) {
    this.cableApp().notify_user = this.cableApp()
      .cable()
      .subscriptions.create(channel, {
        received: function (data) {
          callback(data);
        }
      });
  }

  notifyUser (data) {
    this.setState({
      showNotification: true,
      notification: {
        status: data.description.text.status,
        statusMessage: data.description.text.message
      },
      isImportDisabled: false
    }, () => this.afterMemberImport());
  }

  afterMemberImport () {
    this.getMembersImportReport();
    this.props.reloadMembers();
  }

  getMembersImportReport () {
    getSubscriptionMemberImportReports(this.props.subscriptionId)
      .then(membersImportReport => this.setState({ membersImportReport }));
  }

  importCsv () {
    addSubscriptionMembersFromCSV(this.props.subscriptionId, this.state.membersCsv)
      .then(message => this.setState({
        showNotification: true,
        notification: {
          status: 'success',
          statusMessage: message
        },
        isImportDisabled: true
      }))
      .catch(error => this.setState({
        showNotification: true,
        notification: {
          status: 'error',
          statusMessage: error.message
        }
      }));
    this.setupChannelSubscription(
      'NotifyUsersChannel',
      this.notifyUser
    );
  }

  downloadReport (filename) {
    getDownloadUrl(filename).then(
      downloadUrl => (window.location.href = downloadUrl)
    );
  }

  render () {
    return (
      <>
        <ButtonGroup columns='two'>
          <Button
            url={`/api/v1/management/subscriptions/${this.props.subscriptionId}/members_csv_template.csv`}
            external
            dataTest='member-csv-template'
          >
            CSV Template
          </Button>
          {get(this.state.membersImportReport, ['0', 'status']) === 'generated' && this.state.membersImportReport[0].filename && (
            <Link
              iconLeft='download-arrow'
              onClick={() =>
                this.downloadReport(
                  this.state.membersImportReport[0].filename
                )}
              dataTest='members-import-report'
            > Members Import Report
            </Link>
          )}
          <div>
            <input
              type='file'
              onChange={e => this.setState({ membersCsv: e.target.files[0] })}
              data-test-id='csv-file-input'
            />
            <Button
              disabled={this.state.isImportDisabled || !this.state.membersCsv}
              onClick={e => {
                e.preventDefault();
                this.importCsv();
              }}
              dataTest='import-csv-btn'
            >
              Import CSV
            </Button>
          </div>
        </ButtonGroup>
        {this.state.showNotification && (
          <StatusMessage
            statusMessage={this.state.notification.statusMessage}
            status={this.state.notification.status}
            onCancel={() => this.setState({ showNotification: false, notification: {} })}
          />
        )}
      </>
    );
  }
}
